import SiteFooter from './SiteFooter';
import SiteHeader from './SiteHeader';

function SiteLayout({ children }) {
  return (
    <div className="site-layout">
      <SiteHeader />
      <main className="site-main">
        {children}
      </main>
      <SiteFooter />
    </div>
  );
}

export default SiteLayout;
